import { render } from "./CRInfo.vue?vue&type=template&id=33c9cbde&scoped=true"
import script from "./CRInfo.vue?vue&type=script&lang=js"
export * from "./CRInfo.vue?vue&type=script&lang=js"

import "./CRInfo.vue?vue&type=style&index=0&id=33c9cbde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c9cbde"]])

export default __exports__